import React, { useState } from "react";
import "../styles/contact.scss";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [formSent, setFormSent] = useState(false);

  const [subject] = useState("Kontakt saradnja");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [policy, setPolicy] = useState(
    "Korisnik je uskladio svoju saglasnost sa politikom privatnosti."
  );

  const submitForm = async e => {
    e.preventDefault();

    const emailTemplate = `
      <html>
        <head>
          <style>
            body {
              font-family: 'Montserrat', sans-serif;
              color: #333333;
            }

            * {
              box-sizing: border-box;
            }

            .container {
              width: 100%;
              max-width: 600px;
              margin: 0 auto;
              padding: 20px;
              background-color:#f4f6fc;
            }

            p {
              font-size: 18px;
              margin-top: 0;

            }
            b {
              font-size: 22px;
            }

            a {
              color: #0066cc;
              text-decoration: underline;
            }

    
            .section {
              margin-bottom: 40px;
              margin-top: 20px;
            }

            .section-heading {
              font-size: 20px;
              font-weight: bold;
              margin: 0 0 10px;
            }

            .section-content {
              font-size: 16px;
              margin: 0;
            }

            .header {
              background-color: #ffffff;
              padding: 20px;
              text-align: center;
            }

            .footer {
            
              background: #fff;
              padding: 20px;
              text-align: center;
            }

            .logo {
              width: 100%;
              margin: 0 auto;
            }

            @media only screen and (max-width: 600px) {
              .container {
                padding: 10px;
                width: 100%;
              }
            }
            .message-box {
              background: #fff;
              padding: 15px;
              margin-top: 10px;
            }


            .policy {
              color: #000 !important; 
            }
          </style>
        </head>
        

        <body>
          <div class="container">
            <div class="header">
              <img src='https://www.unijana.rs/static/media/logo.771f8cc8ba89b7c8c55a.png' alt="Logo" class="logo">
            </div>
            <div class="section">
              <b>Naslov:</b> <p>${subject}</p>
              <b>Ime i prezime:</b> <p>${name}</p>
              <b>Broj telefona:</b> <p>${phone}</p>
              <b>Email:</b> <p>${email}</p>
              <b>Politika privatnosti:</b> <p class="policy">${policy}</p>
              <b>Poruka:</b><p class="message-box">${message}</p>
            </div>
            <div class="footer">
              <p style="margin-bottom: 0;">© 2024 Unijana | Sva prava zadržana. <a href="https://www.unijana.rs/politika-privatnosti">Politika privatnosti</a></p>
            </div>
          </div>
        </body>
      </html>
    `;

    try {
      await fetch("/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: name,
          email: email,
          subject: subject,
          message: emailTemplate
        })
      });
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        setFormSent(true);
        setTimeout(() => {
          setFormSent(false);

          setTimeout(() => {
            window.location.reload();
          });
        }, 5000);
      }, 3000);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="contact-page main-container">
      <div className="contact-info-section">
        <h2>Kontaktirajte nas</h2>
        <p>
          Ukoliko imate pitanja, želite da naručite uniforme ili saznate više o
          našim uslugama, slobodno nas kontaktirajte. Naš tim je tu da vam
          pomogne.
        </p>
        <div className="contact-details">
          <p>
            <strong>Email:</strong> office@unijana.rs
          </p>
          <p>
            <strong>Telefon:</strong> +381 000 0000
          </p>
          <p>
            <strong>Lokacija:</strong> Krusevac
          </p>
          <p>
            <strong>Radno vreme:</strong> Ponedeljak - Petak: 9:00 - 17:00
          </p>
        </div>
        <div className="map-container">
          <iframe
            title="map-location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d23125.34999927615!2d21.30422263637095!3d43.571784993048695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475687f1634a407f%3A0xeebd2ea42b43899c!2zS3J1xaFldmFj!5e0!3m2!1sen!2srs!4v1731181675290!5m2!1sen!2srs"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </div>

      <div className="contact-form-section">
        <h3>Javite se</h3>
        <form id="form" method="post" onSubmit={submitForm}>
          <label>
            Ime i prezime *
            <input
              onChange={event => setName(event.target.value)}
              type="text"
              name="name"
              required
            />
          </label>
          <label>
            Email *
            <input
              onChange={event => setEmail(event.target.value)}
              type="email"
              name="email"
              required
            />
          </label>
          <label>
            Telefon
            <input
              onChange={event => setPhone(event.target.value)}
              type="tel"
              name="phone"
            />
          </label>
          <label>
            Poruka *
            <textarea
              onChange={event => setMessage(event.target.value)}
              name="message"
              required
            />
          </label>
          <div className="privacy-policy">
            <input
              onChange={event => setPolicy(event.target.value)}
              id="poli"
              type="checkbox"
              name="privacy"
              required
            />
            <label htmlFor="poli">
              Slažem se sa{" "}
              <a href="/politika-privatnosti">politikom privatnosti</a>
            </label>
          </div>

          <div
            className="send-message"
            style={{ display: formSent ? "block" : "none" }}
          >
            Poruka je poslata, ocekujte odgovor u roku od 24h. Hvala
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Slanje... " : "Pošalji poruku "}
            {loading &&
              <div class="lds-ring">
                <div />
                <div />
                <div />
                <div />
              </div>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
